module.exports = __webpack_public_path__ + "static/img/3.e194092.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/1/zh/3.png
// module id = v04E
// module chunks = 0